import { Button } from 'primereact/button'
import { Toast } from 'primereact/toast'
import { useEffect, useRef, useState } from 'react'
import UsuarioServiceAPI from '../../service/UsuarioServiceAPI'
import { Skeleton } from 'primereact/skeleton'
import { Timeline } from 'primereact/timeline'
import { Fieldset } from 'primereact/fieldset'
import moment from 'moment'
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min'

export default function RemessaBoletos() {
  const toast = useRef()
  const history = useHistory()

  const userServiceApi = new UsuarioServiceAPI()
  const [file, setFile] = useState(null)
  const [loading, setLoading] = useState(false)
  const [remessas, setRemessas] = useState([])

  const handleFileChange = (e) => {
    setFile(e.target.files[0])
    if (e.target.files[0]) {
      toast.current.show({
        severity: 'success',
        summary: 'Arquivo anexado!',
        detail: 'Por favor, confirme o upload!',
        life: 3000,
      })
    }
  }

  const handleSaveFile = async (e) => {
    e.preventDefault()

    if (file?.length == 0) {
      toast.current.show({
        severity: 'error',
        summary: 'Erro',
        detail: 'Por favor, selecione um arquivo antes de enviar',
        life: 3000,
      })
      return
    }

    setLoading(true)
    const formData = new FormData()
    formData.append('file', file)

    userServiceApi
      .uploadArquivoBoleto(formData)
      .then(() => {
        toast.current.show({
          severity: 'success',
          summary: 'Sucesso!',
          detail: 'Arquivo de remessas enviado com sucesso!',
          life: 3000,
        })
        getUltimasRemessas()
      })
      .catch((e) => {
        toast.current.show({
          severity: 'error',
          summary: 'Erro',
          detail: 'Houve um erro ao enviar seu arquivo, tente novamente!',
          life: 3000,
        })
      })
      .finally(() => {
        setLoading(false)
        setFile(null)
      })
  }

  const buildRemessaTimeLineItem = function (ctt) {
    return (
      <>
        <Fieldset legend={ctt?.nomeArquivo}>
          <div>
            <p className='line-height-3 mb-0 my-3 font-semibold text-900'>
              Data do Upload:{' '}
              <span className='font-normal'>
                {moment(ctt.dataUpload).format('DD/MM/YYYY [às] HH:mm:ss')}
              </span>
            </p>
            <p className='line-height-3 mb-0 my-3 font-semibold text-900'>
              Número da remessa: {ctt?.codigoRemessa}
            </p>
            <div className='flex'>
              <div className='ml-auto'>
                <Button
                  onClick={() => history.push(`/boletos?idRemessa=${ctt.id}`)}
                  label='Ver remessa'
                  // icon='pi pi-ticket'
                  className='p-button-outlined'
                />
              </div>
            </div>
          </div>
        </Fieldset>
        <div className=''></div>
      </>
    )
  }

  const getUltimasRemessas = async () => {
    setLoading(true)
    userServiceApi
      .getUltimasRemessas()
      .then(({ data }) => {
        setRemessas(data)
      })
      .finally(() => {
        setLoading(false)
      })
  }

  useEffect(() => {
    getUltimasRemessas()
  }, [])

  return (
    <div className=''>
      <Toast ref={toast} />
      <h5 className='mb-4'>Upload remessa de boletos</h5>
      <form className='card' onSubmit={handleSaveFile}>
        <div
          className='flex flex-column align-items-center p-4'
          style={{ gap: 12 }}
        >
          <div className='flex flex-column align-items-center'>
            <i className='pi pi-cloud-upload' style={{ fontSize: '3rem' }}></i>
            <p>Selecione um arquivo e envie remessas de boletos</p>
          </div>
          <div className='flex align-items-center' style={{ gap: 8 }}>
            <label
              className='p-button flex justify-content-center align-items-center'
              htmlFor='sendFile'
              style={{ height: 33, gap: 4 }}
            >
              <i className='pi pi-cloud-upload'></i>
              <span>Anexar arquivo</span>
            </label>
            <input
              hidden
              type='file'
              accept='.txt'
              onChange={handleFileChange}
              disabled={loading}
              name=''
              id='sendFile'
            />
            <Button
              icon='pi pi-save'
              label='Enviar arquivos'
              disabled={!file}
              className='p-button p-button-success'
              type='submit'
              loading={loading}
            />
          </div>
        </div>
      </form>
      <div className='mt-4'>
        <h5>Últimas remessas</h5>
        <div className='card py-6'>
          {loading ? (
            <Skeleton height='200px' />
          ) : (
            <Timeline
              value={remessas}
              align='alternate'
              className='w-full'
              // marker={item => buildMark(item)}
              content={(item) => buildRemessaTimeLineItem(item)}
            />
          )}
        </div>
      </div>
    </div>
  )
}
